/**
 * Created by Moment on 2016/11/1.
 */

import Vue from 'vue';

Vue.directive('attr', {
  bind: function () {
    if(typeof this.arg !== 'undefined' && typeof this.modifiers !== 'undefined'){
      return false;
    }
    if(this.value){
      this.el.setAttribute(this.arg,Object.keys(this.modifiers)[0])
    }else{
      this.el.removeAttribute(this.arg)
    }
  },
  update: function (newValue, oldValue) {
    if(typeof this.arg !== 'undefined' && typeof this.modifiers !== 'undefined'){
      return false;
    }
    if(newValue){
      this.el.setAttribute(this.arg,Object.keys(this.modifiers)[0])
    }else{
      this.el.removeAttribute(this.arg)
    }
  },
  unbind: function () {

  }
});

/**
 * 全选指令
 */
Vue.directive('check-all',{
  twoWay:true,
  params:['checkData'],
  bind(){
    /**
     - 如果所有的列表的checked属性都为true,则选中全选框,否则不选中全选框
     */
    this.vm.$watch(this.params.checkData,(checkData)=>{
      if(_.every(checkData,(item)=>item.checked)){
        this.set(true)
      }else {
        this.set(false)
      }
    },{deep:true})
  },
  update(checkAll){
    /**
     - 如果全选框被选中,则将列表的所有checked属性转为true,否则转为false
     */
    let list = JSON.parse(JSON.stringify(this.vm[this.params.checkData]))
    if (checkAll) {
      _.each(list,(item) => {
        item.checked = true;
      });
      this.vm[this.params.checkData] = list
    } else {
      _.each(list,(item) => {
        item.checked = false;
      });
      this.vm[this.params.checkData] = list
    }
  }
})
